import React, { useState ,useEffect} from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Button,
  Card,
  OutlinedInput,
  CircularProgress,
  Backdrop
 
} from "@mui/material";

import { GetDataAPi } from "app/apiCall/Postapi";
import { useNavigate } from 'react-router-dom';
import GymRevenueChart from './LineChart'




const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];



const AdminSalesMetrics = () => {
  const navigate = useNavigate()
 
  const [gymRevenue, setGymRevenue] = useState([]); // State for data
  const [month,setMonth] = useState('')
  const [year,setYear] = useState('2025')
  const [monthIndex,setMonthIndex] = useState(0)
  
  const date = new Date();
  const years = date.getFullYear();
  const months = date.getMonth() + 1;
 
  const yearArr = Array.from({ length: years - 2023 }, (_, i) => 2024 + i);

  const [open, setOpen] = useState(false);
    
     const handleClose = () => {
       setOpen(false);
     };
     const handleOpen = () => {
       setOpen(true);
     };

  useEffect(() => {

    setYear(years);
    // setMonth(monthNames[months-1]);
  }, []); // Empt

  useEffect(()=>{
    (async()=>{
       let monthIndex2 = monthNames.indexOf(month)
         setMonthIndex(monthIndex2)
       try {
        handleOpen()
         const res = await GetDataAPi(`/get-revenue-data?year=${year}`)
    
           setGymRevenue(res?.data)
           handleClose()
         
       } catch (error) {
        handleClose()
        console.log("error for gym Revenue",error);
        
       }
    })()
  },[month,year])



   
  

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Gym Sales Metrics
      </Typography>

      

              <hr></hr>
               <Backdrop
                                  sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                                  open={open}
                                  
                                >
                                  <CircularProgress color="inherit" />
                                </Backdrop>

              
      <Grid container  spacing={2}>
    
    
         
        
      </Grid>
     

    
      {/* Revenue Chart */}
      <Box sx={{ mt: 4 }}>
        <Grid container spacing={2} mt={2}>
        <Grid item xs={6}>
        </Grid>
           
        <Grid item xs={3}>
        <FormControl fullWidth>
  <InputLabel htmlFor="class-day">Year</InputLabel>
  <Select
    labelId="class-day-label"
    id="class-day"
    value={year || ""}
    onChange={(e) => setYear(e.target.value)}
    name="year"
    input={<OutlinedInput label="Year" />}
  >
    {
      yearArr?.map((year, index) => (
        <MenuItem key={index} value={year}>{year}</MenuItem>
      ))
    }
    {/* <MenuItem value={2025}>2025</MenuItem>
    <MenuItem value={2024}>2024</MenuItem>
    <MenuItem value={2023}>2023</MenuItem>
    <MenuItem value={2022}>2022</MenuItem>
    <MenuItem value={2021}>2021</MenuItem> */}
  </Select>
</FormControl>

        </Grid>

        <Grid item xs={3}>
        <FormControl fullWidth>
        <InputLabel htmlFor="class-day">Month</InputLabel>
        <Select
          labelId="class-day-label"
          id="class-day"
           value={month || ""}
          onChange={(e)=>setMonth( e.target.value )}
          name="blog_category"
          input={<OutlinedInput label="Month" />}
        >
          {monthNames?.map((category, index) => (
            <MenuItem key={index} value={category}>
              {category}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

        </Grid>

        </Grid>

        <GymRevenueChart  revenueData= {gymRevenue} show={month}  showMonth ={monthIndex}/>
        
      </Box>
    </Box>
  );
};

export default AdminSalesMetrics;
